function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getRegion, getPlatformFromUrl } from '@adsk/acs-sc-web-platform-api';
import loadSegment from './loadSegment';
import segmentApiKey from './segmentApiKey';
import { NODE_ENV } from '../env';
import MockAnalyticsStore from '../MockAnalyticsStore';
import sanitizeTraits from '../sanitizeTraits';

// Determine the project UID from the URL
const PROJECT_REGEX = /\/projects\/([\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12})/;
const REGION = getRegion();
function getProjectUidFromWindowLocation() {
  const url = new URL(window.location.href);
  const match = PROJECT_REGEX.exec(url.pathname);
  if (match) return match[1];
  return null;
}
function addProjectUidToProperties(properties) {
  const projectUid = getProjectUidFromWindowLocation();
  const platform = getPlatformFromUrl().replace('bim360', 'b360');
  return _objectSpread(_objectSpread({
    user_type: platform,
    project_type: platform,
    data_center: REGION,
    screen_height: window.innerHeight,
    screen_width: window.innerWidth
  }, projectUid && {
    project_id: projectUid
  }), properties);
}
const analytics = {
  _queuedEvents: [],
  _queuedIdentifies: [],
  _waitForBaseProperties: null,
  _isInitialized: () => {
    var _window$analytics;
    return !!((_window$analytics = window.analytics) !== null && _window$analytics !== void 0 && _window$analytics.initialized);
  },
  setBaseProperties(newProperties) {
    window.accAnalyticsBaseProperties = _objectSpread(_objectSpread({}, window.accAnalyticsBaseProperties), newProperties);
    if (NODE_ENV === 'development') {
      console.log('%c[analytics.setBaseProperties] %cprops=', 'color:cornflowerblue', 'color:slategrey', window.accAnalyticsBaseProperties);
    }
    analytics._tryToFlushQueues();
  },
  getBaseProperty(propertyName) {
    var _window$accAnalyticsB;
    return (_window$accAnalyticsB = window.accAnalyticsBaseProperties) === null || _window$accAnalyticsB === void 0 ? void 0 : _window$accAnalyticsB[propertyName];
  },
  waitForBaseProperties() {
    for (var _len = arguments.length, propertyNames = new Array(_len), _key = 0; _key < _len; _key++) {
      propertyNames[_key] = arguments[_key];
    }
    analytics._waitForBaseProperties = propertyNames;
    if (NODE_ENV === 'development') {
      console.log('%c[analytics.waitForBaseProperties] %cprops=', 'color:cornflowerblue', 'color:slategrey', analytics._waitForBaseProperties);
    }
  },
  _tryToFlushQueues() {
    var _analytics$_waitForBa;
    if (!analytics._isInitialized()) {
      return;
    }
    if ((_analytics$_waitForBa = analytics._waitForBaseProperties) !== null && _analytics$_waitForBa !== void 0 && _analytics$_waitForBa.some(prop => !(window.accAnalyticsBaseProperties && prop in window.accAnalyticsBaseProperties))) {
      return;
    }
    analytics._waitForBaseProperties = null;
    for (const [userAnalyticsId, traits] of analytics._queuedIdentifies) {
      analytics.identify(userAnalyticsId, traits);
    }
    analytics._queuedIdentifies = [];
    for (const [event, properties] of analytics._queuedEvents) {
      analytics.track(event, properties);
    }
    analytics._queuedEvents = [];
  },
  track(event, properties) {
    var _window, _window$analytics2;
    if (analytics._waitForBaseProperties || !analytics._isInitialized() || !((_window = window) !== null && _window !== void 0 && (_window$analytics2 = _window.analytics) !== null && _window$analytics2 !== void 0 && _window$analytics2.track)) {
      if (NODE_ENV === 'development') {
        console.log('%c[analytics.track%c[QUEUED - NOT SENT]%c] %cevent=%c' + event + ' %cprops=', 'color:cornflowerblue', 'color:red', 'color:cornflowerblue', 'color:slategrey', 'color:cornflowerblue;font-weight:600', 'color:slategrey', properties);
      }
      analytics._queuedEvents.push([event, properties]);
      return;
    }
    properties = addProjectUidToProperties(_objectSpread(_objectSpread({}, window.accAnalyticsBaseProperties), properties));
    if (NODE_ENV === 'production') {
      window.analytics.track(event, properties);
    } else if (NODE_ENV === 'test') {
      MockAnalyticsStore._recordTrack(event, properties);
    } else {
      console.log('%c[analytics.track] %cevent=%c' + event + ' %cprops=', 'color:cornflowerblue', 'color:slategrey', 'color:cornflowerblue;font-weight:600', 'color:slategrey', properties);
    }
  },
  identify(userAnalyticsId, traits) {
    var _window2, _window2$analytics;
    if (!analytics._isInitialized() || !((_window2 = window) !== null && _window2 !== void 0 && (_window2$analytics = _window2.analytics) !== null && _window2$analytics !== void 0 && _window2$analytics.identify)) {
      if (NODE_ENV === 'development') {
        console.log('%c[analytics.identify%c[QUEUED - NOT SENT]%c] %cuserAnalyticsId=%c' + userAnalyticsId + ' %ctraits=', 'color:cornflowerblue', 'color:red', 'color:cornflowerblue', 'color:slategrey', 'color:cornflowerblue;font-weight:600', 'color:slategrey', traits);
      }
      analytics._queuedIdentifies.push([userAnalyticsId, traits]);
      return;
    }
    const sanitizedTraits = sanitizeTraits(traits);
    if (NODE_ENV === 'production') {
      window.analytics.identify(userAnalyticsId, sanitizedTraits);
    } else if (NODE_ENV === 'test') {
      MockAnalyticsStore._recordIdentify(userAnalyticsId, sanitizedTraits);
    } else {
      if (sanitizedTraits) console.log('%c[analytics.identify] %cuserAnalyticsId=%c' + userAnalyticsId + ' %ctraits=', 'color:cornflowerblue', 'color:slategrey', 'color:cornflowerblue;font-weight:600', 'color:slategrey', sanitizedTraits);else console.log('%c[analytics.identify] %userAnalyticsId=%c' + userAnalyticsId, 'color:cornflowerblue', 'color:slategrey', 'color:cornflowerblue;font-weight:600');
    }
  },
  load() {
    if (NODE_ENV === 'test') {
      MockAnalyticsStore._recordLoad();
    }
    return new Promise(resolve => {
      loadSegment(segmentApiKey(), () => {
        if (NODE_ENV === 'development') {
          console.log('%c[analytics.load]', 'color:cornflowerblue');
        }
        if (NODE_ENV === 'test') {
          // in production done by segment script
          window.analytics = window.analytics || {};
          window.analytics.initialized = true;
        }
        const event = new CustomEvent('alloyAnalyticsLoaded');
        window.dispatchEvent(event);
        resolve();
      });
    });
  }
};
window.addEventListener('alloyAnalyticsLoaded', () => {
  analytics._tryToFlushQueues();
}, {
  once: true
});
if (!window.skipAlloyAnalyticsLoad) {
  void analytics.load();
}
export default analytics;
//# sourceMappingURL=index.js.map